import { getProfile, getReviews } from 'Api/companyApi'
import { getCompanyAnswers } from 'Api/QuestionApi'
import { parseProfile, parseReview } from 'Parsers/profileParser'
import { apiErrorList } from 'Services/restAdviser'
import { parseAnswerList } from 'Parsers/questionParser'
import pascalToCamelCase from 'Services/pascalToCamelCase'

const state = {
  requesting: {
    info: false,
    questionList: false,
    reviewList: false,
  },

  visibility: {
    phone: true,
    website: true,
    quotation: true,
    location: true,
  },

  info: {
    id: 0,
    idSnet: 0,
    name: '',
    description: '',
    slug: '',
    logo: '',
    about: '',
    services: '',
    advantanges: '',
    endorsements: '',
    website: '',
    phone: {
      ddd: '',
      number: ''
    },
    skillList: [],
    serviceList: [],
    is360Partner: false
  },

  rating: {
    score: null,
    opnions: 0,
    goodService: false,
    fastCompany: false,
    proposals: {
      total: 0,
      since: ''
    },
  },

  location: {
    zipcode: '',
    city: '',
    state: '',
    neighborhood: '',
    address: '',
    number: '',
    details: '',
  },

  mediaList: [],
  questionList: [],
  reviewList: [],

  errorList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, { type, errorList }) {
    state.requesting[type] = false

    state.errorList = errorList
  },

  set_visibility(state, visibility) {
    state.visibility = Object.assign(state.visibility, visibility)
  },

  set_info(state, info) {
    state.info = Object.assign(state.info, info)
  },

  set_rating(state, rating) {
    state.rating = Object.assign(state.rating, rating)
  },

  set_location(state, location) {
    state.location = Object.assign(state.location, location)
  },

  set_media_list(state, mediaList) {
    state.mediaList = mediaList
  },

  set_question_list(state, questionList) {
    state.questionList = questionList
  },

  set_review_list(state, reviewList) {
    state.reviewList = reviewList
  },
}

const actions = {
  getSyncInfo({ commit }, data) {
    const { info, visibility, rating, location, mediaList } = parseProfile(pascalToCamelCase(data))

    commit('set_info', info)
    commit('set_visibility', visibility)
    commit('set_location', location)
    commit('set_media_list', mediaList)

    commit('set_rating', rating)
  },

  async getAsyncInfo({ commit }, slug) {
    commit('request_start', 'info')

    try {
      const { data } = await getProfile(slug)
      const { info, visibility, rating, location, mediaList } = parseProfile(data)

      commit('request_success', 'info')

      commit('set_info', info)
      commit('set_visibility', visibility)
      commit('set_location', location)
      commit('set_media_list', mediaList)
      commit('set_rating', rating)

      return data
    } catch (err) {
      const errorList = apiErrorList(err)

      commit('request_failure', { errorList,  type: 'info' })

      throw err
    }
  },

  async getQuestionList({ commit, state }) {
    commit('request_start', 'questionList')

    try {
      const { idSnet } = state.info

      const { data } = await getCompanyAnswers(idSnet)
      const questionList = parseAnswerList(data)

      commit('request_success', 'questionList')
      commit('set_question_list', questionList)

      return data
    } catch (err) {
      if (err.status = 404) {
        commit('request_success', 'questionList')

        return []
      }

      const errorList = apiErrorList(err)

      commit('request_failure', { errorList,  type: 'questionList' })

      throw err
    }
  },

  async getReviewList({ commit, state }) {
    commit('request_start', 'reviewList')

    try {
      const { id } = state.info
      const { data } = await getReviews(id)

      const reviewList = data.map(parseReview)
      commit('set_review_list', reviewList)

      commit('request_success', 'reviewList')

      return data
    } catch (err) {
      commit('request_failure', 'reviewList')

      throw err
    }
  }
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}